import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'op-settings-dashboard',
    templateUrl: './settings-dashboard.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SettingsDashboardComponent {
}